import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { eClusterEnv, IRootScope } from "@models";
import { StorageService } from "./storage.service";


@NgService({
    token: Token.BundleLoaderService,
    dependencies: [
        Token.$RootScope,
        Token.$OcLazyLoad,
        Token.StorageService
    ]
})
export class BundleLoaderService {
    constructor(
        private $rootScope: IRootScope,
        private $ocLazyLoad: oc.ILazyLoad,
        private storageService: StorageService
    ) {

    }

    public cachebuster(url: string, minifyIfNotDebug: boolean) {
        if (minifyIfNotDebug && this.$rootScope.clusterEnv != eClusterEnv.dev && !this.$rootScope.context.debug) {
            let index = url.lastIndexOf(".");
            url = url.slice(0, index) + ".min" + url.slice(index);
        }
        return `${url}?v=${this.$rootScope.cacheBuster}`;
    }

    protected getBundleUrl(relativePath: string, minifyIfNotDebug) {
        let url = this.storageService.getFileUrl(relativePath);
        return this.cachebuster(url, minifyIfNotDebug);
    }

    private _libs: { [key: string]: (string | oc.ITypedModuleConfig | oc.IModuleConfig)[] } = {
        [Token.SnapLib.key]: [
            {
                files: [
                    this.getBundleUrl("snap.css", true),
                    this.getBundleUrl(`loc/loc-snap.${this.$rootScope.clientLanguage}.js`, false)
                ]
            },
            {
                files: [
                    this.getBundleUrl(`snap.js`, true),  
                    this.getBundleUrl(`kbsnap.js`, true),
                ],
                serie: true
            }            
        ],
        [Token.HandsontableLib.key]: [
            this.getBundleUrl("lib/handsontable.full.min.js", false),
            this.getBundleUrl("lib/handsontable.full.min.css", false)
        ],
        [Token.HighchartsLib.key]: [
            this.getBundleUrl("lib/highcharts.js", false)
        ],
        [Token.MonacoLoaderLib.key]: [
            this.getBundleUrl("lib/monaco-editor/min/vs/loader.js", false)
        ],
        [Token.AdminLib.key]: [
            {
                files: [
                    this.getBundleUrl("admin.js", true),
                    this.getBundleUrl("admin-templates.js", false),
                    this.getBundleUrl(`loc/loc-admin.${this.$rootScope.clientLanguage}.js`, false)
                ],
                serie: true
            }
        ],
        [Token.Recaptcha.key]: [
            {
                files: [
                    "https://www.google.com/recaptcha/api.js?render=" + this.$rootScope.recaptchaToken
                ],
                serie: true
            }
        ],
        [Token.Viewer.key]: [
            this.getBundleUrl("viewer.js", true)
        ],
        [Token.Creator.key]: [
            this.getBundleUrl("creator.js", true)
        ]
    };

    public load(libraries: Token[], paralell = true) {
        let urls: (string | oc.ITypedModuleConfig | oc.IModuleConfig)[] = [];
        libraries.forEach(lib => urls.pushArray(this._libs[lib.key]));
        return this.$ocLazyLoad.load(urls, { serie: !paralell });
    }
}
